import React, { useState, useEffect } from "react";
import sanitizeHtml from "sanitize-html";

const About = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchPage = async () => {
            try {
                const response = await fetch(
                    'https://zenplacepula.zenplacepula.com/wp-json/wp/v2/pages?slug=o-meni&_embed'
                );
                
                if (!response.ok) {
                    throw new Error(`Došlo je do greške: ${response.status}`);
                }
                
                const json = await response.json();
                
                // Check if page exists
                if (!json || json.length === 0) {
                    throw new Error("Stranica nije pronađena");
                }
                
                setData(json[0]); // Get first page from array
            } catch (err) {
                setError(err.message);
            }
        };
        
        fetchPage();
    }, []);

    if (error) return <p>Greška: {error}</p>;
    if (!data) return <p>Učitavanje...</p>;

    return (
        <div className="container py-3 clanak-single">
            <div className="row">
                <div className="col-md-8 m-auto mb-4 clanak-zaglavlje">
                    <p>{data?._embedded?.["wp:term"]?.[0]?.[0]?.name}</p>
                    <h1>{data?.title?.rendered}</h1>
                </div>
                
                <div className="col-md-9 m-auto">
                    <img 
                        className="w-100 mb-5 clanak-fotka" 
                        src={data?._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.medium_large?.source_url} 
                        alt={data?._embedded?.["wp:featuredmedia"]?.[0]?.alt_text || "Default description"}
                    />
                </div>
                
                <div className="col-md-10 m-auto mb-5 clanak-sadrzaj">
                    <div
                        dangerouslySetInnerHTML={{
                            __html: sanitizeHtml(data?.content?.rendered || "", {
                                allowedTags: ["p", "strong", "em", "ul", "ol", "li", "h1", "h2", "h3", "br", "a"],
                                allowedAttributes: {
                                    a: ["href", "title"],
                                    img: ["src", "alt", "width", "height", "style"],
                                    "*": ["style"]
                                }
                            })
                        }}
                    />
                </div>
            </div>
        </div>
    );
};

export default About;